<template>
  <div>
    <!-- CARD 1: Provider Selection (NEW) -->
    <v-card flat class="mb-4">
      <v-card-title>
        <v-icon class="mr-2">{{ icons.mdiSwapHorizontal }}</v-icon>
        Provedor de Emissão NFSe
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <v-radio-group v-model="settingsForm.nfse_provider" row>
              <v-radio label="CloudDFE (API Paga)" value="clouddfe"></v-radio>
              <v-radio
                label="Nacional (Governo)"
                value="nacional"
                :disabled="!providerStatus.has_certificate"
              ></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" md="6">
            <v-chip
              :color="providerStatusColor"
              label
            >
              <v-icon left small>{{ icons.mdiCheckCircle }}</v-icon>
              Ativo: {{ providerStatusText }}
            </v-chip>
          </v-col>
        </v-row>

        <v-alert
          v-if="settingsForm.nfse_provider === 'nacional' && !providerStatus.has_certificate"
          type="warning"
          dense
          text
        >
          <v-icon left>{{ icons.mdiAlertCircle }}</v-icon>
          Certificado digital necessário para usar Nacional.
          <a href="#certificado">Enviar certificado</a>
        </v-alert>
      </v-card-text>
    </v-card>

    <!-- CARD 2: CloudDFE Settings (NEW - Conditional) -->
    <v-card flat class="mb-4" v-show="settingsForm.nfse_provider === 'clouddfe'">
      <v-card-title>
        <v-icon class="mr-2">{{ icons.mdiCloud }}</v-icon>
        Configurações CloudDFE
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="settingsForm.token_emit_nfse"
              outlined
              label="Token CloudDFE"
              hint="Token de autenticação da API CloudDFE"
              persistent-hint
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-radio-group v-model="settingsForm.ambiente_nf" row label="Ambiente">
              <v-radio label="Produção" value="1"></v-radio>
              <v-radio label="Homologação" value="2"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- CARD 3: Nacional Settings (NEW - Conditional) -->
    <v-card flat class="mb-4" v-show="settingsForm.nfse_provider === 'nacional'">
      <v-card-title>
        <v-icon class="mr-2">{{ icons.mdiBankOutline }}</v-icon>
        Configurações Nacional (Governo)
      </v-card-title>
      <v-card-text>
        <!-- Enable/Disable Toggle -->
        <v-row>
          <v-col cols="12">
            <v-switch
              v-model="settingsForm.nacional_enabled"
              :disabled="!canEnableNacional"
              label="Habilitar Ambiente Nacional"
              hint="Ative para começar a emitir NFSe pelo ambiente do governo"
              persistent-hint
            ></v-switch>
          </v-col>
        </v-row>

        <!-- Nacional Environment -->
        <v-row>
          <v-col cols="12" md="6">
            <v-radio-group
              v-model="settingsForm.nacional_ambiente"
              row
              label="Ambiente Nacional"
              :disabled="!settingsForm.nacional_enabled"
            >
              <v-radio label="Homologação (Testes)" value="homologacao"></v-radio>
              <v-radio label="Produção" value="producao"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>

        <!-- Certificate Alerts -->
        <v-row>
          <v-col cols="12">
            <!-- Expired Certificate -->
            <v-alert
              v-if="providerStatus.has_certificate && !providerStatus.certificate_valid"
              type="error"
              dense
              text
            >
              <v-icon left>{{ icons.mdiAlertCircle }}</v-icon>
              Certificado digital vencido. Envie um novo certificado para usar o Nacional.
            </v-alert>

            <!-- Expiring Soon -->
            <v-alert
              v-else-if="providerStatus.days_until_expiration <= 30 && providerStatus.days_until_expiration > 0"
              type="warning"
              dense
              text
            >
              <v-icon left>{{ icons.mdiClockAlertOutline }}</v-icon>
              Certificado expira em {{ providerStatus.days_until_expiration }} dias ({{ providerStatus.certificate_expires_at }})
            </v-alert>

            <!-- Valid Certificate -->
            <v-alert
              v-else-if="providerStatus.certificate_valid"
              type="success"
              dense
              text
            >
              <v-icon left>{{ icons.mdiCheckCircle }}</v-icon>
              Certificado válido até {{ providerStatus.certificate_expires_at }}
            </v-alert>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card-text class="d-flex align-center flex-wrap">
      <v-form v-model="fiscalSettingsSide" class="row col-xs">
        <div class="col-md">
          <v-card flat>
            <v-card-title>
              <v-icon class="mr-2">{{ icons.mdiCog }}</v-icon>
              Configurações Fiscais
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col>
                  <v-radio-group v-model="settingsForm.ambiente_nf" row>
                    <v-radio label="Produçao" value="1"></v-radio>
                    <v-radio label="Homologação" value="2"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="3">
                  <v-select v-model="settingsForm.crt" outlined :items="crt" label="Codigo de Regime Tributario"
                    hide-details="auto" dense>
                  </v-select>
                </v-col>
                <v-col md="3">
                  <v-text-field v-model="settingsForm.aliquota" outlined label="Aliquota" :rules="[rules.required]"
                    hide-details="auto" dense></v-text-field>
                </v-col>
                <v-col md="3">
                  <v-text-field v-model="settingsForm.ccm" outlined label="Inscriçao Municipal (CCM)"
                    :rules="[rules.required]" hide-details="auto" dense></v-text-field>
                </v-col>
                <v-col md="3">
                  <v-text-field v-model="settingsForm.password" outlined label="Senha Prefeitura"
                    :rules="[rules.required]" hide-details="auto" dense></v-text-field>
                </v-col>
                <v-col md="6">
                  <v-text-field v-model="settingsForm.code_service" outlined label="Codigo de Serviço"
                    hide-details="auto" dense></v-text-field>
                </v-col>
                <v-col md="6">
                  <v-text-field v-model="settingsForm.code_tax_city" outlined label="Codigo de tributação da cidade"
                    hide-details="auto" dense></v-text-field>
                </v-col>
                <v-col md="6">
                  <v-text-field v-model="settingsForm.csc" outlined label="CSC"
                    hide-details="auto" dense></v-text-field>
                </v-col>
                <v-col md="6">
                  <v-text-field v-model="settingsForm.csc_id" outlined label="CSC_ID"
                    hide-details="auto" dense></v-text-field>
                </v-col>
                <v-col md="6">
                  <v-text-field v-model="settingsForm.token_emit_nfse" outlined label="Token emissor"
                    hide-details="auto" dense></v-text-field>
                </v-col>
                <v-col md="3">
                  <v-text-field v-model="settingsForm.invoice_last_number" outlined label="Número da última nf-e"
                    :rules="[rules.onlyNumbers]" hide-details="auto" dense></v-text-field>
                </v-col>
                <v-col md="3">
                  <v-text-field v-model="settingsForm.invoice_series" outlined label="Série nf-e"
                    :rules="[rules.onlyNumbers]" hide-details="auto" dense></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <!-- <v-divider></v-divider>
          <v-card flat>
            <v-card-title>
              <v-icon class="ma-2">{{ icons.mdiTextBox }}</v-icon>
              Certificado Digital
            </v-card-title>
            <v-card-text>
              <DigitalCertificateComponent></DigitalCertificateComponent>
            </v-card-text>
          </v-card> -->
        </div>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-text class="d-flex justify-md-end justify-center">
      <v-btn color="success" @click="submitForm" class="text-capitalize mr-3">
        <v-icon>
          {{ icons.mdiContentSave }}
        </v-icon>
        Salvar Informações
      </v-btn>
    </v-card-text>
  </div>
</template>

<script>
import DigitalCertificateComponent from "@/components/administration/company/forms/DigitalCertificate.vue";
import {
  mdiTextBox,
  mdiCog,
  mdiContentSave,
  // NEW ICONS
  mdiSwapHorizontal,
  mdiCloud,
  mdiBankOutline,
  mdiAlertCircle,
  mdiCheckCircle,
  mdiClockAlertOutline,
} from "@mdi/js";
import { OPTIONS_CRT } from "@/constants/option";
import formMixin from "@/util/mixins/formMixin";

export default {
  components: {
    DigitalCertificateComponent,
  },

  mixins: [formMixin],

  data() {
    return {
      icons: {
        mdiTextBox,
        mdiCog,
        mdiContentSave,
        // NEW ICONS
        mdiSwapHorizontal,
        mdiCloud,
        mdiBankOutline,
        mdiAlertCircle,
        mdiCheckCircle,
        mdiClockAlertOutline,
      },

      crt: OPTIONS_CRT,

      menus: {
        emissao: false,
        vencimento: false,
      },

      certificateSide: null,
      fiscalSettingsSide: null,

      // NEW - Provider Status
      providerStatus: {
        current_provider: 'clouddfe',
        nacional_enabled: false,
        has_certificate: false,
        certificate_valid: false,
        certificate_expires_at: null,
        days_until_expiration: null,
        is_ready: false,
      },

      loadingProviderStatus: false,

      settingsForm: {
        id: null,
        aliquota: null,
        ambiente_nf: null,
        version: null,
        company_name: null,
        cnpj: null,
        cpf: null,
        im: null,
        cmun: null,
        siglaUF: null,
        path_file: null,
        csc: null,
        csc_id: null,
        ccm: null,
        password: null,
        crt: null,
        token_emit_nfse: null,
        code_service: null,
        code_tax_city: null,
        invoice_series: null,
        invoice_last_number: null,
        // NEW FIELDS - Nacional
        nfse_provider: 'clouddfe',
        nacional_ambiente: 'homologacao',
        nacional_enabled: false,
      },

      certificateForm: {
        certificate: null,
        emissao: null,
        vencimento: null,
      },

      dirty: {
        company: false,
        integrations: false,
        signature: false,
        fiscalSettings: false,
      },
    };
  },

  computed: {
    canEnableNacional() {
      return this.providerStatus.has_certificate &&
             this.providerStatus.certificate_valid;
    },

    effectiveProvider() {
      if (this.settingsForm.nacional_enabled &&
          this.settingsForm.nfse_provider === 'nacional') {
        return 'nacional';
      }
      return 'clouddfe';
    },

    providerStatusText() {
      if (!this.providerStatus.is_ready) {
        return 'Configuração incompleta';
      }
      return this.effectiveProvider === 'nacional'
        ? 'Nacional (Governo)'
        : 'CloudDFE (API)';
    },

    providerStatusColor() {
      if (!this.providerStatus.is_ready) return 'warning';
      return this.settingsForm.nacional_enabled ? 'success' : 'primary';
    },
  },

  watch: {
    'settingsForm.nfse_provider'(newProvider) {
      if (newProvider === 'nacional') {
        // Disable Nacional if no valid certificate
        if (!this.canEnableNacional) {
          this.settingsForm.nacional_enabled = false;
        }
      }
    },

    'settingsForm.nacional_enabled'(enabled) {
      if (enabled && !this.canEnableNacional) {
        // Revert if cannot enable
        this.$nextTick(() => {
          this.settingsForm.nacional_enabled = false;
        });

        // Show warning
        this.$toast.warning('Certificado digital válido necessário para habilitar Nacional');
      }
    },
  },

  async mounted() {
    this.settingsForm = {
      id: this.$store.state.auth.user.company.company_nfe_config.id,
      ambiente_nf: this.$store.state.auth.user.company.company_nfe_config.ambiente_nf,
      version: this.$store.state.auth.user.company.company_nfe_config.version,
      company_name: this.$store.state.auth.user.company.name,
      cnpj: this.$store.state.auth.user.company.cnpj,
      cpf: this.$store.state.auth.user.user.cpf,
      im: this.$store.state.auth.user.company.inscricao_municipal,
      cmun: this.$store.state.auth.user.company.main_address.city_code,
      siglaUF: this.$store.state.auth.user.company.main_address.state,
      path_file: this.$store.state.auth.user.company.company_nfe_config.path_file,
      csc: this.$store.state.auth.user.company.company_nfe_config.csc,
      csc_id: this.$store.state.auth.user.company.company_nfe_config.csc_id,
      ccm: this.$store.state.auth.user.company.company_nfe_config.ccm,
      password: this.$store.state.auth.user.company.company_nfe_config.password,
      crt: this.$store.state.auth.user.company.company_nfe_config.crt,
      aliquota: this.$store.state.auth.user.company.company_nfe_config.aliquota,
      token_emit_nfse: this.$store.state.auth.user.company.company_nfe_config.token_emit_nfse,
      code_service: this.$store.state.auth.user.company.company_nfe_config.code_service,
      code_tax_city: this.$store.state.auth.user.company.company_nfe_config.code_tax_city,
      invoice_series: this.$store.state.auth.user.company.company_nfe_config.invoice_series,
      invoice_last_number: this.$store.state.auth.user.company.company_nfe_config.invoice_last_number,
      nfse_provider: this.$store.state.auth.user.company.company_nfe_config.nfse_provider || 'clouddfe',
      nacional_ambiente: this.$store.state.auth.user.company.company_nfe_config.nacional_ambiente || 'homologacao',
      nacional_enabled: this.$store.state.auth.user.company.company_nfe_config.nacional_enabled || false,
    };

    // Fetch provider status from backend (sync provider on initial mount)
    await this.fetchProviderStatus(true);
  },

  methods: {
    async fetchProviderStatus(syncProvider = false) {
      this.loadingProviderStatus = true;

      try {
        const response = await this.$http.$get('company/nfse-config/provider-status');

        this.providerStatus = {
          current_provider: response.current_provider,
          nacional_enabled: response.nacional_enabled || false,
          has_certificate: response.has_certificate,
          certificate_valid: response.certificate_valid,
          certificate_expires_at: response.certificate_expires_at,
          days_until_expiration: response.days_until_expiration || null,
          is_ready: response.is_ready,
        };

        // Only sync provider selection on initial mount, not when user is changing it
        if (syncProvider) {
          this.settingsForm.nfse_provider = response.current_provider;
        }

        // Always sync these fields
        this.settingsForm.nacional_enabled = response.nacional_enabled === true;
        this.settingsForm.nacional_ambiente = response.nacional_ambiente || 'homologacao';

      } catch (error) {
        this.$toast.error('Erro ao carregar status do provedor NFSe');
      } finally {
        this.loadingProviderStatus = false;
      }
    },

    async submitForm() {
      // Validation: Nacional selected but not enabled
      if (this.settingsForm.nfse_provider === 'nacional' &&
          !this.settingsForm.nacional_enabled) {
        this.$toast.warning('Habilite o Nacional antes de salvar');
        return;
      }

      // Validation: CloudDFE without token
      if (this.settingsForm.nfse_provider === 'clouddfe' &&
          !this.settingsForm.token_emit_nfse) {
        this.$toast.error('Token CloudDFE é obrigatório');
        return;
      }

      // Validation: Nacional without certificate
      if (this.settingsForm.nfse_provider === 'nacional' &&
          !this.providerStatus.has_certificate) {
        this.$toast.error('Certificado digital é obrigatório para Nacional');
        return;
      }

      try {
        await this.$http.$put(
          `company-settings/${this.settingsForm.id}`,
          this.settingsForm
        );

        this.$toast.success('Configurações NFSe salvas com sucesso');

        // Reload provider status (sync provider after successful save)
        await this.fetchProviderStatus(true);

      } catch (error) {
        // Handle specific errors
        if (error.response?.status === 422) {
          const errors = error.response.data.errors;
          Object.keys(errors).forEach(key => {
            this.$toast.error(errors[key][0]);
          });
        } else {
          this.$toast.error('Erro ao salvar configurações NFSe');
        }
      }
    },
  },
};
</script>
